import React from 'react';
import { C } from './styles/theme';

const cardStyle = { background: C.white, borderRadius: 12, padding: 20, border: `1px solid ${C.g200}`, transition: 'transform 0.2s, box-shadow 0.2s' };

export default function Card({ children, style, onClick }) {
  return <div style={{ ...cardStyle, ...style, cursor: onClick ? 'pointer' : 'default' }} onClick={onClick}>{children}</div>;
}
